import React, { useContext } from 'react'
import TopNavigation from 'app/React/Components/Header/TopNavigation/TopNavigation'
import Logo from 'app/React/Components/Header/Logo'
import { ConfiguratorContext } from 'app/React/ConfiguratorContainer'

export default function Header() {
  const {
    currentVariant,
    isMenuOpen,
    setIsMenuOpen,
    currentStep,
    isDealerConfigurator,
    strings,
    setShowAsOrdinaryDealer,
    dealerEmail,
    dealerDebitorEmails,
    getVariantsFromModelYears
  } = useContext(ConfiguratorContext)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const stepIndex = () => {
    const stepsArray = Object.values(currentVariant.steps)
    const index = stepsArray.findIndex((step) => step.step_id == currentStep) + 1
    return index < 1 ? 1 : index
  }

  const showToggleSwitch = isDealerConfigurator &&
    dealerDebitorEmails.includes(dealerEmail) &&
    getVariantsFromModelYears(true).length > 0

  return (
    <header>
      <Logo />
      <TopNavigation />
      <div className='top-title'>
        <div>
          <span>{stepIndex()}.</span>
          &nbsp;
          {currentVariant.steps[currentStep].title}
        </div>

        {showToggleSwitch && (
          <div className='toggle-switch-wrapper'>
            <div id="show-as-ordinary-dealer-label">{strings.header.internSlashDealer}</div>
            <div className='toggle-switch'>
              <input
                disabled={stepIndex() !== 1}
                className='toggle-input'
                id='toggle'
                name='show-as-ordinary-dealer'
                type='checkbox'
                onChange={event => setShowAsOrdinaryDealer(event.target.checked)}
              />
              <label
                className='toggle-label' htmlFor='toggle'
                title={strings.header.show_as_ordinary_dealer}
              />
            </div>
          </div>
        )}
      </div>
      <div
        id='config-navigation-toggle'
        onClick={toggleMenu}
        className={['config-navigation__toggle-icon', isMenuOpen ? 'open' : null].join(' ')}
      >
        <div className='open' />
      </div>
    </header>
  )
}
